import { LINK_FIELD_KEYS } from '../_const';
import AppWrappedTextbox from '../../AppWrappedTextbox';
import { isValidEmail } from 'utils';

const PersonalEmailAddressField = ({ initialValue, formik }) => {
	const shouldShow =
		!initialValue || (initialValue && !isValidEmail(initialValue));

	return (
		shouldShow && (
			<AppWrappedTextbox
				name={LINK_FIELD_KEYS.EMAIL_ADDRESS}
				isRequired
				label='Personal Email Address'
				formik={formik}
			/>
		)
	);
};

export default PersonalEmailAddressField;
